import React from 'react';
import { useTranslation } from 'react-i18next';

const Goals = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language; // Текущий язык ('ru' или 'tg')


    return (
        <div>
            <main className="main">
                <section className="section">
                    <div className="section__container">
                        <h2 className="section__title">{t('monetaryPolicy.title')}</h2>
                        <p className="section__text">
                            {t('monetaryPolicy.description')}
                        </p>
                    </div>
                </section>
                <section className="section">
                    <div className="section__container">
                        <h2 className="section__title">{t('policyGoal.title')}</h2>
                        <p className="section__text">
                            {t('policyGoal.description')}
                        </p>
                    </div>
                </section>
                <section className="section">
                    <div className="section__container">
                        <h2 className="section__title">{t('implementation.title')}</h2>
                        <p className="section__text">
                            {t('implementation.description')}
                        </p>
                        <ul className="section__list">
                            <li className="section__list-item">{t('implementation.items.first')}</li>
                            <li className="section__list-item">{t('implementation.items.second')}</li>
                            <li className="section__list-item">{t('implementation.items.third')}</li>
                        </ul>
                    </div>
                </section>
                <section className="section">
                    <div className="section__container">
                        <h2 className="section__title">{t('priceStability.title')}</h2>
                        <p className="section__text">
                            {t('priceStability.description')}
                        </p>
                    </div>
                </section>

                <section class="section">
            <div class="section__container">
             
                <p class="section__text">
                    <a style={{color:"#000"} } target="_blank" 
                    href={`/documents/monetary_policy_${currentLanguage}.pdf`} >
                    {t('monetaryPolicy.file-title')}</a>
                </p>
            </div>
        </section>
            </main>
        </div>
    );
}

export default Goals;